import { render, staticRenderFns } from "./PesquisaAtaView.vue?vue&type=template&id=c2e1e720"
import script from "./PesquisaAtaView.vue?vue&type=script&lang=js"
export * from "./PesquisaAtaView.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAtaView.vue?vue&type=style&index=0&id=c2e1e720&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports